import type { ChannelResource } from "@octopusdeploy/octopus-server-client";
import { useLegacyDoBusyTask } from "~/components/DataBaseComponent/useLegacyDoBusyTask";
import { Form } from "~/components/form/Form/Form";
import type { EditChannelWorkflowInput } from "~/workflows/EditChannelWorkflowInput";
import { WorkflowContent } from "~/workflows/WorkflowContent";
import { workflows } from "~/workflows/workflows";
import { CreateOrEditChannelForm } from "./CreateOrEditChannelForm";
import { useChannelForm } from "./useChannelForm";
export interface EditChannelWorkflowProps {
    workflowInput: EditChannelWorkflowInput;
    completeWorkflow: (output: ChannelResource) => void;
}
export function EditChannelWorkflow({ workflowInput: { project, channel, lookupData, gitRefValidationError, gitRef }, completeWorkflow }: EditChannelWorkflowProps) {
    const { lifecycles } = lookupData;
    const { doBusyTask } = useLegacyDoBusyTask();
    const { model, setModel, formProps, createSaveAction, getFieldError, lifecycleOptions } = useChannelForm(project, channel, lifecycles, "Channel drawer", completeWorkflow);
    return (<WorkflowContent.Drawer workflow={workflows.editChannelWorkflow} primaryAction={createSaveAction({ accessibleName: "Confirm Edit Channel" })} title={model.Name}>
            <Form {...formProps}>
                <CreateOrEditChannelForm doBusyTask={doBusyTask} model={model} setModel={setModel} getFieldError={getFieldError} lifecycleOptions={lifecycleOptions} channel={channel} project={project} gitRef={gitRef} gitRefValidationError={gitRefValidationError} lookupData={lookupData}/>
            </Form>
        </WorkflowContent.Drawer>);
}
